import React from "react";
import "./admin.scss";
import { Link, useNavigate } from "react-router-dom";

export default function AdminPanel({ children }) {
  const [activeMenu, setActiveMenu] = React.useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    navigate("/login?returnTo=/admin");
    return null;
  }

  if (user.role === "user") {
    navigate("/");
    return null;
  }

  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = '/'
  };

  return (
    <div className="app">
      {/* SIDEBAR */}
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="brand">
          <div className="avatar">A</div>
          <div>
            <h2>World Adventure Tours</h2>
            <span>Admin Console</span>
          </div>
        </div>

        <nav className="menu">
          <Link
            to="/admin"
            className={activeMenu === "dashboard" ? "active" : ""}
            onClick={() => {
              setActiveMenu("dashboard");
              setSidebarOpen(false);
            }}
          >
            Dashboard
          </Link>

          <Link
            to="/admin/trips"
            className={activeMenu === "trips" ? "active" : ""}
            onClick={() => {
              setActiveMenu("trips");
              setSidebarOpen(false);
            }}
          >
            Manage Trips
          </Link>

          <Link
            to="/admin/categories"
            className={activeMenu === "categories" ? "active" : ""}
            onClick={() => {
              setActiveMenu("categories");
              setSidebarOpen(false);
            }}
          >
            Categories
          </Link>

          <Link
            to="/admin/bookings"
            className={activeMenu === "bookings" ? "active" : ""}
            onClick={() => {
              setActiveMenu("bookings");
              setSidebarOpen(false);
            }}
          >
            Bookings
          </Link>

          <Link
            to="/admin/reviews"
            className={activeMenu === "reviews" ? "active" : ""}
            onClick={() => {
              setActiveMenu("reviews");
              setSidebarOpen(false);
            }}
          >
            Reviews
          </Link>

          <Link
            to="/admin/profile"
            className={activeMenu === "profile" ? "active" : ""}
            onClick={() => {
              setActiveMenu("profile");
              setSidebarOpen(false);
            }}
          >
            Profile
          </Link>
        </nav>

        <div className="sidebar-footer">
          <button onClick={logoutHandler}>Logout</button>
        </div>
      </aside>

      {/* CONTENT */}
      <main className="content">
        <header className="topbar">
          <button
            className="menu-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
          >
            ☰
          </button>

          <h1>Overview</h1>

          <div className="actions">
            <img
              className="profile"
              src="https://i.pravatar.cc/40"
              alt="profile"
            />
          </div>
        </header>

        <section className="panel">{children}</section>
      </main>
    </div>
  );
}
